import { Error } from "@/types/error.definition";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Specialty } from "../../types/specialty.definition";
import { clearError, setError } from "./errorSlice";

interface SpecialtiesState {
  specialties: Specialty[];
}

const initialState: SpecialtiesState = {
  specialties: [],
};

const specialtiesSlice = createSlice({
  name: "specialties",
  initialState,
  reducers: {
    getSpecialtiesRequest: () => {
      clearError();
    },
    getSpecialtiesSuccess: (state, action: PayloadAction<Specialty[]>) => {
      state.specialties = action.payload;
      clearError();
    },
    getSpecialtiesFailure: (_state, action: PayloadAction<Error>) => {
      setError(action.payload);
    },
  },
});

export const {
  getSpecialtiesRequest,
  getSpecialtiesSuccess,
  getSpecialtiesFailure,
} = specialtiesSlice.actions;
export default specialtiesSlice.reducer;
